export default __webpack_public_path__ + "static/media/Background 5_00000.3b33c0a2.png";